//---TRANSILLUMINATOR-----------------------------:
export const createTransilluminator= (data) => {
  //data = {id, type}
  return { type: "CREATE_TRANSILLUMINATOR", payload: data}
}

export const setGelInTransilluminator = (data) => {
  //data = {newItem} newItem = {type, id}
  return { type: "PLACE_GEL_ON_TRANSILLUMINATOR", payload: data }
}

export const turnOnTransilluminator = (data) => {
  //data = {newItem} newItem = {type, id}
  return { type: "TURN_ON_TRANSILLUMINATOR", payload: data }
}

export const transilluminatorOpen = (data) => {
  //data = {open}
  return { type: "TRANSILLUMINATOR_OPEN", payload: data }
}

export const transilluminatorGelExmined = (data) => {
  return { type: "TRANSILLUMINATOR_GEL_EXAMINED", payload: data }
}

export const toggleToolTipTransillimunatorControls = data => {
  return { type: "SHOW_TOOL_TIP_TRANSILLUMINATOR_CONTROLS", payload: data };
};